import React from 'react';
import { useThemeClasses } from '../../lib/themes/utils';

const SubHeading = ({ children }: { children: React.ReactNode }) => {
  const theme = useThemeClasses();
  
  return (
    <h3 className={`
      text-lg sm:text-xl 
      ${theme.typography.headingMedium}
      ${theme.text.primary}
      mt-8 mb-6
      relative
      flex items-center
    `}>
      <div className={`w-1 h-6 ${theme.backgrounds.gradientPrimary} ${theme.radius.small} mr-3`}></div>
      {children}
    </h3>
  );
};

export default SubHeading;
